export class Pager {
  public static EVENT_SOURCE = 'pagination';

  private readonly _element: JQuery<HTMLElement>;

  constructor(element: JQuery<HTMLElement>) {
    this._element = element;

    this.setupElementHandlers();
  }

  private setupElementHandlers() {
    const inputId = this._element.data('input-id');
    const input = $('#' + inputId);

    this._element.find('.pagination__page').on('click', (e) => {
      const pageNumber = e.target.getAttribute('data-page');
      if (pageNumber == null) {
        return;
      }

      input.val(pageNumber);
      input.trigger('change', [{ source: Pager.EVENT_SOURCE }]);
    });

    this._element.find('.pagination__page-control').on('click', (e) => {
      const pageNumber = $(e.target).closest('li').data('page');
      if (pageNumber == null) {
        return;
      }

      input.val(pageNumber);
      input.trigger('change');
    });
  }
}
